import { Buildings } from "@phosphor-icons/react";

interface ISectionOurServices {
  id: string;
}

export const SectionOurServices = ({ id }: ISectionOurServices) => {
  return (
    <div className="content-area m-16 max-w-full" id={id}>
      <div className="mb-6 grid w-full items-center justify-center md:mb-28 lg:flex lg:justify-between">
        <div className="flex items-center gap-4 text-center md:gap-8 lg:mb-0">
          <span className="hidden h-[3.5rem] w-[3.5rem] place-content-center rounded-full border border-primaria-claro sm:grid md:h-[4.5rem] md:w-[4.5rem]">
            <Buildings size={40} className="text-black" />
          </span>
          <div className="grid gap-2">
            <h2 className="text-32 font-semibold uppercase text-primaria-claro sm:text-40">
              Conheça Nossos Serviços
            </h2>
          </div>
        </div>
      </div>
      <ul className="grid w-full grid-cols-1 justify-center gap-8 p-4 md:grid-cols-2 md:gap-4 md:p-0 lg:gap-8">
        <li className="flex grid-rows-[10rem,14rem] flex-col rounded-[0.25rem] border-2 transition-all ease-linear hover:border-black">
          <img
            src="/projeto/service-04.webp"
            width="384"
            alt="Antecipação do FGTS"
            data-nuxt-img=""
            className="h-auto w-auto rounded-t-[0.25rem]"
          />
          <div className="rounded-b-[0.25rem] border-t-0 border-borda-claro p-8">
            <h3 className="btn-text-2 mb-3 font-semibold">
              Crédito através da antecipação do seu FGTS
            </h3>
            <p className="body-text-3 mb-6 text-escrita-claro">
              Utilize o seu saldo de FGTS
              <br /> para conquistar sua tranquilidade, <br />
              viajar, deixar as contas em dia.
            </p>
            <a
              href="https://www.santanacred.com.br/saquefgts1"
              title="Saiba mais"
              rel="nofollow"
              className="group flex max-w-fit items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro"
            >
              <span>Saiba mais</span>
              <svg
                className=" transition-all ease-linear group-hover:rotate-45"
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z"
                  fill="#1658A6"
                ></path>
              </svg>
            </a>
          </div>
        </li>
        <li className="flex grid-rows-[10rem,14rem] flex-col rounded-[0.25rem] border-2 border-borda-claro transition-all ease-linear hover:border-black">
          <img
            src="/projeto/service-01.webp"
            width="384"
            height="160"
            alt="Crédito Consignado"
            data-nuxt-img=""
            className="h-auto w-auto rounded-t-[0.25rem]"
          />
          <div className="rounded-b-[0.25rem] border-t-0 p-8">
            <h3 className="btn-text-2 mb-3 font-semibold">Crédito Consignado</h3>
            <p className="body-text-3 mb-6 text-escrita-claro">
              Crédito para aposentados e pensionistas <br /> do INSS. <br />
              Servidores públicos, Municipal, Estadual, Federal
            </p>
            <a
              href="https://www.santanacred.com.br/inss1"
              title="Saiba mais"
              rel="nofollow"
              className="group flex max-w-fit items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro"
            >
              <span>Saiba mais</span>
              <svg
                className=" transition-all ease-linear group-hover:rotate-45"
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z"
                  fill="#1658A6"
                ></path>
              </svg>
            </a>
          </div>
        </li>
        <li className="flex grid-rows-[10rem,14rem] flex-col rounded-[0.25rem] border-2 border-borda-claro transition-all ease-linear hover:border-black">
          <img
            src="/projeto/service-02.webp"
            width="384"
            height="160"
            alt="Portabilidade &amp; Refinanciamento "
            data-nuxt-img=""
            className="h-auto w-auto rounded-t-[0.25rem]"
          />
          <div className="rounded-b-[0.25rem] border-t-0 p-8">
            <h3 className="btn-text-2 mb-3 font-semibold">Portabilidade &amp; Refinanciamento </h3>
            <p className="body-text-3 mb-6 text-escrita-claro">
              Oportunidade de portar seu contrato <br />
              consignado, reduzir as taxas, <br />
              refinanciando e liberando um novo crédito
              <br />
              <br />
              <br />
            </p>
            <a
              href="https://www.santanacred.com.br/inss1"
              title="Saiba mais"
              rel="nofollow"
              className="group flex max-w-fit items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro"
            >
              <span>Saiba mais</span>
              <svg
                className=" transition-all ease-linear group-hover:rotate-45"
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z"
                  fill="#1658A6"
                ></path>
              </svg>
            </a>
          </div>
        </li>
        <li className="flex grid-rows-[10rem,14rem] flex-col rounded-[0.25rem] border-2 border-borda-claro transition-all ease-linear hover:border-black">
          <img
            src="/projeto/service-03.webp"
            width="384"
            height="160"
            alt="Cartão de Crédito Consignado"
            data-nuxt-img=""
            className="h-auto w-auto rounded-t-[0.25rem]"
          />
          <div className="rounded-b-[0.25rem] border-t-0 p-8">
            <h3 className="btn-text-2 mb-3 font-semibold">Cartão Consignado / Cartão Beneficio</h3>
            <p className="body-text-3 mb-6 text-escrita-claro">
              Mais limite e mais crédito, com opção de <br />
              Crédito e Saque em dinheiro, no limite <br />
              do cartão <br />
            </p>
            <a
              href="https://www.santanacred.com.br/inss1"
              title="Saiba mais"
              rel="nofollow"
              className="group flex max-w-fit items-center border-b border-primaria-claro pb-2 font-semibold text-primaria-claro"
            >
              <span>Saiba mais</span>
              <svg
                className=" transition-all ease-linear group-hover:rotate-45"
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.0168 13.0311C1.28008 13.0289 1.53189 12.9213 1.71752 12.7317L10.0013 4.30536L10.0013 8.96462C10.0013 9.23384 10.1066 9.49205 10.294 9.68242C10.4814 9.87279 10.7356 9.97974 11.0006 9.97974C11.2657 9.97974 11.5199 9.87279 11.7073 9.68242C11.8947 9.49205 12 9.23384 12 8.96462L12 1.85875C11.9985 1.7258 11.9713 1.59444 11.92 1.47213C11.8186 1.22463 11.6249 1.02791 11.3813 0.924916C11.2608 0.872762 11.1315 0.845142 11.0006 0.843627L4.00512 0.843628C3.74007 0.843628 3.48588 0.950578 3.29846 1.14095C3.11105 1.33132 3.00576 1.58952 3.00576 1.85875C3.00576 2.12798 3.11105 2.38618 3.29846 2.57655C3.48588 2.76692 3.74007 2.87388 4.00512 2.87388L8.59203 2.87387L0.296556 11.2883C0.202605 11.3827 0.128019 11.4951 0.0771149 11.619C0.0262116 11.7429 8.54222e-07 11.8758 8.65777e-07 12.01C8.77332e-07 12.1442 0.0262117 12.2771 0.077115 12.401C0.128019 12.5249 0.202605 12.6373 0.296556 12.7317C0.390797 12.828 0.503097 12.9041 0.62681 12.9555C0.750525 13.0069 0.883136 13.0326 1.0168 13.0311Z"
                  fill="#1658A6"
                ></path>
              </svg>
            </a>
          </div>
        </li>
      </ul>
    </div>
  );
};
